import { api } from "./configs/axiosConfigs"

export const UserERPAPI = {
    getVerifyERP: async (iduser:any) => {
        const response = await api.get(
            `/userERP/verify/${iduser}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createUserERP: async (data: any) => {
        const response = await api.post(
            '/userERP/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editUserERP: async (id: number, data:object) => {
        const response = await api.patch(
            `/userERP/update/${id}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteUserERP: async (id: number) => {
        const response = await api.delete(
            `/userERP/delete/${id}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}